<!-- eslint-disable global-require -->
<template>
  <div class="introduction_Container">
    <section class="introduction_Container_Reports-introduction p-2 p-md-3">
      <h2
        v-if="contextBarcode.barcodeStatus !== 'Reports Ready'"
        class="text-primary"
      >
        An Introduction to Your Reports
      </h2>
      <div
        class="d-flex flex-column flex-md-row  py-2 p-md-3 align-items-center intro-first-section"
      >
        <div
          class="d-flex flex-column data-section"
        >
          <div
            v-if="contextBarcode.saBarcode"
            class="d-flex align-items-center py-2"
            :class="contextBarcode.duBarcode !== ''? '': 'mb-md-5 pt-md-2 pb-md-3'"
          >
            <img
              src="@/assets/images/icons/intropage-dna-icon.svg"
            >
            <h5 class="mx-1 text-black">
              We collect your <b>DNA</b> from your saliva sample
            </h5>
          </div>
          <div
            v-if="contextBarcode.stBarcode"
            class="d-flex align-items-center py-2"
            :class="contextBarcode.haveDNAData && contextBarcode.duBarcode !== '' ? 'data-transform-right':'mb-md-5' "
          >
            <img
              src="@/assets/images/icons/intropage-bacterial-dna-icon.svg"
            >
            <h5 class="mx-1 text-black">
              We collect <b>Bacterial DNA </b>from your stool sample
            </h5>
          </div>
          <div
            class="d-flex align-items-center py-md-2 pt-2"
            :class="contextBarcode.haveDNAData? '': 'mt-md-2'"
          >
            <img
              src="@/assets/images/icons/intropage-lifestyle-data-icon.svg"
            >
            <h5 class="mx-1 text-black">
              We study your <b>health and lifestyle data </b>
            </h5>
          </div>

        </div>
        <div class="d-flex flex-row">
          <img
            v-if="contextBarcode.haveDNAData && contextBarcode.duBarcode !== ''"
            src="@/assets/images/intropage-connectors.svg"
            class="connectors"
          >
          <img
            v-else
            src="@/assets/images/intropage-st-only-connectors.svg"
            class="connectors"
          >
          <img
            v-if="contextBarcode.haveDNAData && contextBarcode.duBarcode !== ''"
            id="introImg"
            :src="require('@/assets/images/intro-video.gif')"
          >
          <img
            v-else-if="contextBarcode.haveDNAData && contextBarcode.duBarcode === ''"
            id="introSaOnlyImg"
            src="@/assets/images/SA_image.png"
          >
          <img
            v-else
            id="introStOnlyImg"
            src="@/assets/images/intro-st-only.png"
          >
        </div>
      </div>
      <div
        v-if="contextBarcode.haveDNAData"
        class="d-flex flex-column flex-md-row py-3"
        style="border-top: solid 1px #DFDFDF;"
      >
        <div v-if="contextBarcode.duBarcode !== ''">
          <img
            src="@/assets/images/icons/microbiome-analysis.svg"
            class="mb-1"
          >
          <h3 class="text-primary">
            Gut Microbiome Analysis:
          </h3>
          <h5 class="text-secondary-grey">
            We measure the abundance of bacteria detected in your gut. The results are used to identify bacterial imbalances that need correction via specific foods.
          </h5>
          <h5
            class="underlined cursor-pointer learn-more"
            @click="$router.push({ name: 'gut-microbiome-analysis' })"
          >
            Learn More
          </h5>
        </div>
        <feather-icon
          v-if="contextBarcode.duBarcode !== ''"
          icon="PlusIcon"
          size="25"
          class="plus-icon my-2 mx-md-3 text-primary"
        />
        <div>
          <img
            src="@/assets/images/icons/dna-analysis.svg"
            class="mb-1"
          >
          <h3 class="text-primary">
            DNA Analysis:
          </h3>
          <h5 class="text-secondary-grey">
            {{ contextBarcode.duBarcode !== '' ? 'We read the sequence of letters present in your DNA to assess your predisposition, or likelihood, to various symptoms and biological traits.': 'We read the sequence of letters present in your DNA (using microarray technology) to assess your predisposition to various symptoms and biological traits.' }}
          </h5>
          <h5
            class="underlined cursor-pointer learn-more"
            @click="navigateLearnMorePages('dna-analysis')"
          >
            Learn More
          </h5>
        </div>
      </div>
    </section>
    <section
      class="introduction_Container_Calculate-scores d-flex flex-column-reverse flex-md-row align-items-center justify-content-center px-2 p-md-4"
      :class="contextBarcode.haveDNAData? ' ': 'mb-1 mb-md-3'"
    >
      <div
        class="mx-md-2 p-0 mt-3"
      >
        <h2 class="text-primary">
          How Do We Calculate Your Scores?
        </h2>
        <ul
          v-for="(info,index) in calculateScoresInformation"
          :key="index"
          class="p-0 mt-2 ml-1"
        >
          <li>
            {{ info }}
          </li>
        </ul>
        <h5
          v-if="!contextBarcode.haveDNAData"
          class="cursor-pointer underlined text-primary mb-2"
          @click="navigateLearnMorePages('gut-microbiome-analysis')"
        >
          Learn More
        </h5>
      </div>
      <img
        src="@/assets/images/NH-Webapp-Test-tube.gif"
      >
    </section>
    <section
      v-if="contextBarcode.haveDNAData"
      class="introduction_Container_Dna-info d-flex  flex-column flex-md-row p-1 p-md-3 align-items-center justify-content-center"
    >
      <img
        src="@/assets/images/Gut_dna.png"
      >
      <div class="p-1 p-md-3 mx-md-2 content-section">
        <h2 class="text-primary mt-2">
          Your DNA is the genetic code that reveals your body’s innate strengths, weaknesses and potential health risks.
        </h2>
        <ul class="text-secondary-grey p-0 ml-1">
          <li class="mt-1">
            We study variations in your DNA code to assess your predisposition to various biological traits and symptoms.
          </li>
          <li class="mt-1">
            For eg. some variants can modify the way you break down food, like a cup of coffee. Some could be the reason you are more fond of sweets!
          </li>
        </ul>
      </div>
    </section>
    <section
      v-if="contextBarcode.haveDNAData"
      class="introduction_Container_Dna-more-info p-2 p-md-3"
    >
      <h2 class="text-primary mt-1">
        What could your DNA say about you?
      </h2>
      <h5 class="text-secondary-grey my-1">
        Here are a few insights covered in your reports. Read your reports to know more.
      </h5>
      <div class="wrapper">
        <b-card
          v-for="(item, index) in dnaInformation"
          :key="index"
        >
          <img
            :src="item.icon"
          >
          <h4 class="mt-1">
            {{ item.title }}
          </h4>
          <p>{{ item.info }}</p>
        </b-card>
      </div>
    </section>
    <section
      v-if="contextBarcode.stBarcode !== ''"
      class="introduction_Container_Gutmicrobiome-guide d-flex flex-column-reverse flex-md-row align-items-center justify-content-center p-1 p-md-2"
    >
      <div
        class="p-md-3 p-1 mx-md-2 guide-content"
      >
        <h2 class="text-primary mt-1">
          Your Gut Microbiome guides multiple bodily functions including your overall immunity and mental health.
        </h2>
        <ul class="text-secondary-grey p-0 ml-1">
          <li class="mt-1">
            It is home to trillions of bacteria that thrive via a symbiotic relationship with your body - their host.
          </li>
          <li class="mt-1">
            This ecosystem inside you performs vital functions like maintaining your immunity, making hormones, breaking down food and more.
          </li>
        </ul>
      </div>
      <img
        src="@/assets/images/gutmicrobiomeInfo.png"
      >
    </section>
    <RecomDesignedToCard />
    <FoodPyramid :show-food-list-data="false" />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import RecomDesignedToCard from '@/components/RecomDesignedToCard.vue'
import FoodPyramid from '@/components/FoodPyramid.vue'

export default {
  components: {
    RecomDesignedToCard,
    FoodPyramid,
  },
  computed: {
    ...mapGetters({
      contextBarcode: 'auth/GET_CONTEXT_BARCODE',
    }),
    dnaInformation() {
      return [
        {
          // eslint-disable-next-line global-require
          icon: require('@/assets/images/icons/immunity.png'),
          title: 'Immunity',
          info: 'Do you have a higher risk for allergies and immune-mediated conditions? We help you find out.',
        },
        {
          // eslint-disable-next-line global-require
          icon: require('@/assets/images/icons/long-term-memory.png'),
          title: 'Long-term memory',
          info: 'Are you someone who has a stronger memory for long term events or occurrences?',
        },
        {
          // eslint-disable-next-line global-require
          icon: require('@/assets/images/icons/chronotype.png'),
          title: 'Chronotype',
          info: 'Are you more of a morning person or night person? This impacts the quality of your sleep',
        },
        {
          // eslint-disable-next-line global-require
          icon: require('@/assets/images/icons/stress-response.png'),
          title: 'Stress Response',
          info: 'Do you get very stressed often? Your ability to manage stress can be affected by genetic factors!',
        },
        {
          // eslint-disable-next-line global-require
          icon: require('@/assets/images/icons/addiction-habits.png'),
          title: 'Addiction Habits',
          info: 'Genetic factors can modify your response to substances like alcohol or nicotine.',
        },
        {
          // eslint-disable-next-line global-require
          icon: require('@/assets/images/icons/sweet-tooth-predisposition.png'),
          title: 'Sweet Tooth Predisposition',
          info: 'Do you have a higher tendency to consume sweet-tasting & sugary foods?',
        },

      ]
    },
    calculateScoresInformation() {
      let info
      if (this.contextBarcode.haveDNAData && this.contextBarcode.duBarcode !== '') {
        info = [' We compare your DNA & Gut Microbiome data to 1000’s of samples that are matched to your age group.', 'Your Health Scores indicate where you stand relatively when compared with our reference dataset.', ' We also analyse your DNA for certain biological traits such as memory, stress, caffeine response. etc.']
      } else if (this.contextBarcode.haveDNAData && this.contextBarcode.duBarcode === '') {
        info = [' We compare your DNA data to 1000s of samples that are matched to your ancestry', 'Your Health Trends indicate where you stand relatively when compared with our reference dataset.', ' We also analyze your genetic disposition for biological traits like nutrient levels, stress response, caffeine response, etc']
      } else {
        info = [' We measure the abundance of bacteria detected in your gut. The results are used to identify bacterial imbalances that need correction via specific foods.', ' We compare your Gut Microbiome data to 1000’s of samples that are matched to your age group.', ' Your Health Scores indicate where you stand relatively when compared with our reference dataset.']
      }
      return info
    },
  },
  methods: {
    navigateLearnMorePages(routeName) {
      this.$router.push({ name: routeName })
    },
  },
}

</script>
<style lang="scss">
.introduction_Container{
    &_Reports-introduction{
        background-color: #FFFFFF;
        .intro-first-section{
            @media (min-width: 768px) and (max-width: 1024px){
              flex-direction: column !important;
              background-position-y: 5rem;
              background-position-x: 3rem;
          }

          @media (max-width: 1024px) {
          background-image:  url('../assets/images/intropage-connectors-mobile.svg');
          background-repeat: no-repeat;
          background-size: 21rem;
          background-position-y: 2.5rem;
          }

        }
        .connectors{
          @media (max-width: 1024px) {
            display: none;
          }
        }
        .data-section{
          @media (min-width: 1025px){
              width:26%;
              margin-left: 4rem;
          }
        }
        .data-transform-right{
          @media (min-width: 1025px){
              transform: translate(6rem,0rem);
          }
        }
        #introImg{
          height: 17rem;
          object-fit: contain;
          border-radius: 50%;
          @media (min-width: 768px){
              height: 21rem;
          }

        }
        #introStOnlyImg{
          height: 23rem;
          object-fit: contain;
          @media (min-width: 768px){
              height: 28rem;
          }

        }
        #introSaOnlyImg{
          height: 23rem;
          width: 26rem;
          object-fit: cover;
          @media (min-width: 768px){
              height: 32rem;
          }
        }
        .plus-icon{
          height: 2rem;
          width: 2rem;
          @media (min-width:768px) {
            height: 4rem;
            width: 4rem;
          }
        }
        .learn-more{
          color: #0A6ECA;
        }
    }
    &_Calculate-scores{
        background-color: #EBE9FF;
                   @media (min-width: 768px) and (max-width: 1024px){
                    padding: 0rem !important;
          }
         img{
            height: 15rem;
            width: 25rem;
            object-fit: cover;
        }
        @media (min-width: 768px){
          img{
            height: 25rem;
            width: 25rem;
            object-fit: cover;
        }
        }
        li{
          color: black;
          font-family: 'Circular Std';
          font-style: normal;
          font-weight: 450;
          font-size: 16px;
          line-height: 22px;
        }

    }
    &_Dna-info{
        background-color: #FFFFFF;
        img{
            height: 20rem;
            width: 20rem;
        }
        @media (min-width: 768px) and (max-width: 1024px){
            padding: 1rem !important;
            img{
            height: 15rem;
            width: 15rem;
        }
          .content-section{
            padding: 0rem !important;
          }
          }
        li{
          font-family: 'Circular Std';
          font-style: normal;
          font-weight: 450;
          font-size: 16px;
          line-height: 130%;
        }
        ul {
          list-style-type: '- ';
        }
    }
    &_Dna-more-info{
        background-color: transparent;
          @media (min-width: 768px) and (max-width: 1024px) {
              padding: 2rem !important;
            }

        .wrapper{
          display: grid;
          gap: 1rem;
          @media (min-width: 768px) and (max-width: 1024px) {
              grid-template-columns: 1fr 1fr;
            }

          @media (min-width: 1025px) {
              grid-template-columns: 1fr 1fr 1fr;
            }
        }
        .card{
            height: auto;
            margin-bottom: 0rem;
            h4{
              color: rgba(22, 22, 22, 1);
            }
            p {
              color: #515151;
            }
        }
    }
    &_Gutmicrobiome-guide{
        background-color: #ECEBFD;
            img{
            height: 23rem;
            width: 23rem;
            object-fit: contain;
        }
        @media (min-width: 768px) and (max-width: 1024px) {
          .guide-content{
            padding: 0rem !important;
          }
          img{
            height: 15rem;
            width: 17rem;
        }
        }
        @media (min-width: 1025px) {
              img{
                  height: 29rem;
                  width: 30rem;
        }
        }
                li{
          font-family: 'Circular Std';
          font-style: normal;
          font-weight: 450;
          font-size: 18px;
          line-height: 130%;
        }
        ul {
    list-style-type: '- ';
}
    }
    &_recommendations{
        background-color: transparent;
        h4,h2{
          color: black;
          font-weight: 700;
        }
        p{
          margin-bottom: 0;
          color: #515151;
        }
        img{
          width: 4rem;
          height: 4rem;
        }
         @media (min-width: 768px) and (max-width: 1024px) {
        .recommendations-content{
          flex-direction: column !important;
        }
      }

    }
    .text-secondary-grey{
      color: #515151;
    }
}
</style>
